import { dateLocale } from '../../i18n/format'

/** "2026", or "2025/26" when a period crosses New Year */
export const yearLabel = (start: string, end: string) => {
  const sy = start.slice(0, 4)
  const ey = end.slice(0, 4)
  return sy === ey ? sy : `${sy}/${ey.slice(2)}`
}

/** X-axis label for a series bucket: "jan. 26" per month, "05.03" per day */
export function bucketLabeller(granularity: 'day' | 'month') {
  const monthFormat = new Intl.DateTimeFormat(dateLocale(), { month: 'short', year: '2-digit' })
  return (bucket: string) => {
    if (granularity === 'month') {
      const [y, m] = bucket.split('-').map(Number)
      return monthFormat.format(new Date(y, m - 1, 1))
    }
    const [, m, d] = bucket.split('-')
    return `${d}.${m}`
  }
}
